class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    // Ouverture au survol uniquement sur les appareils à pointeur fin capables
    // de hover (desktop). Les écrans tactiles gardent le comportement au clic.
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.closeTimer = null;

    this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
    this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  open() {
    if (this.mainDetailsToggle.open) return;

    // Un seul sous-menu ouvert à la fois.
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.open) menu.close();
    });

    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onHoverEnter() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimer);
    this.open();
  }

  onHoverLeave() {
    if (!this.hoverQuery.matches) return;
    // Petit délai de tolérance pour ne pas fermer si l'on ressort/rentre vite.
    this.closeTimer = setTimeout(() => this.close(), 120);
  }

  onSummaryClick(event) {
    // En desktop, le survol pilote l'ouverture : on neutralise le toggle au
    // clic souris pour éviter qu'un clic referme aussitôt ce que le survol a
    // ouvert. Le clavier (Entrée/Espace, event.detail === 0) garde le toggle
    // natif pour l'accessibilité.
    if (this.hoverQuery.matches && event.detail > 0) {
      event.preventDefault();
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
